import { idaman } from '../config';
import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

export const oidcConfig = {
  authority: idaman.OIDC_AUTHORITY,
  client_id: idaman.OIDC_CLIENT_ID,
  client_secret: idaman.OIDC_CLIENT_SCR,
  redirect_uri: idaman.OIDC_REDIRECT_URI,
  post_logout_redirect_uri: idaman.OIDC_REDIRECT_URI,
  response_type: 'code',
  scope: 'openid profile email',
  automaticSilentRenew: true,
  filterProtocolClaims: true,
  loadUserInfo: true,
};

export const userManager = new UserManager({
  ...oidcConfig,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
});
